import { arrayMove } from '@dnd-kit/sortable';
import { HandoffField } from '../services/handoffApi';

export const MAX_FIELDS = 15;

/**
 * Reorders fields after a drag-and-drop operation and updates their order property.
 */
export const reorderFields = (
  fields: HandoffField[],
  activeId: string,
  overId: string
): HandoffField[] => {
  const oldIndex = fields.findIndex((f) => f.id === activeId);
  const newIndex = fields.findIndex((f) => f.id === overId);

  if (oldIndex !== -1 && newIndex !== -1) {
    const newFields = arrayMove(fields, oldIndex, newIndex);
    return newFields.map((field, index) => ({
      ...field,
      order: index + 1,
    }));
  }

  return fields;
};

/**
 * Validates if a field can be added based on duplicates and limits.
 */
export const canAddField = (
  existingFields: HandoffField[],
  newFieldId: string,
  maxFields: number = MAX_FIELDS
): { canAdd: boolean; error?: string } => {
  if (existingFields.length >= maxFields) {
    return { canAdd: false, error: `Maximum of ${maxFields} fields allowed.` };
  }

  if (existingFields.some((f) => f.id === newFieldId)) {
    return { canAdd: false, error: 'Field already added.' };
  }

  return { canAdd: true };
};

/**
 * Formats master field to handoff field structure.
 */
export const mapMasterToHandoff = (masterField: any, nextOrder: number): HandoffField => {
  return {
    id: masterField.id || '',
    label: (masterField.label || '').toString(),
    type: masterField.type || 'text',
    required: !!masterField.required,
    order: nextOrder,
    source: 'master',
    description: (masterField.description || '').toString(),
    example: (masterField.example || '').toString(),
  };
};
